// Shared scale math for the orthographic on-screen scale bar and the
// optional reference grid, so the two always agree: a grid cell is exactly
// one scale-bar length. Both target ~120 px and snap to a 1/2/5 × 10^k value.

export const TARGET_PIXELS = 120;

// Round a target world distance to a 1/2/5 × 10^k value so it reads as a clean
// number on screen. `lead` is the leading digit (1, 2 or 5) of the result.
export const niceRound = (target: number): { value: number; lead: 1 | 2 | 5 } => {
  if (!isFinite(target) || target <= 0) return { value: 1, lead: 1 };
  const pow = Math.pow(10, Math.floor(Math.log10(target)));
  const norm = target / pow;
  if (norm < 1.5) return { value: 1 * pow, lead: 1 };
  if (norm < 3.5) return { value: 2 * pow, lead: 2 };
  if (norm < 7.5) return { value: 5 * pow, lead: 5 };
  return { value: 10 * pow, lead: 1 };
};
